import { recoveryBreakdownColumns } from "../columns";
import { WithTitle } from "../shared";

import { CustomTable } from "@/components/reusables/data-table/CustomTable";

type TProps = {
  recoveryBreakDown: object;
};

const RecoveryBreakdown: React.FC<TProps> = ({ recoveryBreakDown }) => {
  const finalData = Object?.values(recoveryBreakDown);

  return (
    <section>
      <WithTitle title='Recovery Breakdown' className='max-w-full min-w-0 p-4'>
        <CustomTable
          empty={{
            subtitle: "Recovery breakdown data seems to be empty.",
            small: true,
          }}
          title='Recovery Breakdown'
          columns={recoveryBreakdownColumns}
          data={finalData?.length ? finalData : []}
          filters={false}
          id='recovery-breakdown'
          hide={{
            filters: true,
            functions: true,
          }}
        />
      </WithTitle>
    </section>
  );
};

export default RecoveryBreakdown;
